import angular, { ISCEService } from 'angular';

TrustAsHtmlFilterFactory.$inject = ['$sce'];

function TrustAsHtmlFilterFactory($sce: ISCEService) {
  function TrustAsHtmlFilter(value: string) {
    return $sce.trustAsHtml(value);
  }

  return TrustAsHtmlFilter;
}

export const TrustAsHtmlFilterModule = angular
  .module('acme.common.filter.trustAsHtml', [])
  .filter('trustAsHtml', TrustAsHtmlFilterFactory).name;
